const { createReducer } = require('../helpers')

const {
  GET_CAMPAIGN_LIST,
  GET_CAMPAIGN_LIST_SUCCESS,
  GET_CAMPAIGN_LIST_ERROR,
  GET_CAMPAIGN_LIST_RESET,
  CREATE_CAMPAIGN,
  CREATE_CAMPAIGN_SUCCESS,
  CREATE_CAMPAIGN_ERROR,
  CREATE_CAMPAIGN_RESET,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_ERROR,
  UPDATE_CAMPAIGN_RESET,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_ERROR,
  DELETE_CAMPAIGN_RESET,
  GET_ROUTE_LIST,
  GET_ROUTE_LIST_SUCCESS,
  GET_ROUTE_LIST_ERROR,
  GET_ROUTE_LIST_RESET,
  CREATE_ROUTE,
  CREATE_ROUTE_SUCCESS,
  CREATE_ROUTE_ERROR,
  CREATE_ROUTE_RESET,
  UPDATE_ROUTE,
  UPDATE_ROUTE_SUCCESS,
  UPDATE_ROUTE_ERROR,
  UPDATE_ROUTE_RESET,
  DELETE_ROUTE,
  DELETE_ROUTE_SUCCESS,
  DELETE_ROUTE_ERROR,
  DELETE_ROUTE_RESET,
  DO_TEST_AUDIO_CALL,
  DO_TEST_AUDIO_CALL_SUCCESS,
  DO_TEST_AUDIO_CALL_ERROR,
  DO_TEST_AUDIO_CALL_RESET,

  GET_PRIORITY_TEAM_LIST,
  GET_PRIORITY_TEAM_LIST_SUCCESS,
  GET_PRIORITY_TEAM_LIST_ERROR,
  GET_PRIORITY_TEAM_LIST_RESET,

  GET_PRIORITY_TEAM_DETAIL,
  GET_PRIORITY_TEAM_DETAIL_SUCCESS,
  GET_PRIORITY_TEAM_DETAIL_ERROR,
  GET_PRIORITY_TEAM_DETAIL_RESET,

  CREATE_PRIORITY_TEAM,
  CREATE_PRIORITY_TEAM_SUCCESS,
  CREATE_PRIORITY_TEAM_ERROR,
  CREATE_PRIORITY_TEAM_RESET,

  UPDATE_PRIORITY_TEAM,
  UPDATE_PRIORITY_TEAM_SUCCESS,
  UPDATE_PRIORITY_TEAM_ERROR,
  UPDATE_PRIORITY_TEAM_RESET,

  ADD_DOCTOR_TO_PRIORITY_TEAM,
  ADD_DOCTOR_TO_PRIORITY_TEAM_SUCCESS,
  ADD_DOCTOR_TO_PRIORITY_TEAM_ERROR,
  ADD_DOCTOR_TO_PRIORITY_TEAM_RESET,

  DELETE_PRIORITY_TEAM,
  DELETE_PRIORITY_TEAM_SUCCESS,
  DELETE_PRIORITY_TEAM_ERROR,
  DELETE_PRIORITY_TEAM_RESET,
} = require('./constants')

const initialState = {
  campaignList: {
    data: null,
    loading: false,
    error: null,
  },
  createCampaign: {
    data: null,
    loading: false,
    error: null,
  },
  updateCampaign: {
    data: null,
    loading: false,
    error: null,
  },
  deleteCampaign: {
    data: null,
    loading: false,
    error: null,
  },
  routeList: {
    data: null,
    loading: false,
    error: null,
  },
  createRoute: {
    data: null,
    loading: false,
    error: null,
  },
  updateRoute: {
    data: null,
    loading: false,
    error: null,
  },
  deleteRoute: {
    data: null,
    loading: false,
    error: null,
  },
  doTestAudioCall: {
    data: null,
    loading: false,
    error: null,
  },
  priorityTeamList: {
    data: null,
    loading: false,
    error: null,
  },
  priorityTeamDetail: {
    data: null,
    loading: false,
    error: null,
  },
  createPriorityTeam: {
    data: null,
    loading: false,
    error: null,
  },
  updatePriorityTeam: {
    data: null,
    loading: false,
    error: null,
  },
  addDoctorToPriorityTeam: {
    data: null,
    loading: false,
    error: null,
  },
  deletePriorityTeam: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer({
  [GET_CAMPAIGN_LIST]: draft => ({
    campaignList: {
      ...draft.campaignList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_CAMPAIGN_LIST_SUCCESS]: (draft, action) => ({
    campaignList: {
      ...draft.campaignList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_CAMPAIGN_LIST_ERROR]: (draft, action) => ({
    campaignList: {
      ...draft.campaignList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_CAMPAIGN_LIST_RESET]: () => ({
    campaignList: { ...initialState.campaignList },
  }),

  [CREATE_CAMPAIGN]: draft => ({
    createCampaign: {
      ...draft.createCampaign,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [CREATE_CAMPAIGN_SUCCESS]: (draft, action) => ({
    createCampaign: {
      ...draft.createCampaign,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CREATE_CAMPAIGN_ERROR]: (draft, action) => ({
    createCampaign: {
      ...draft.createCampaign,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CREATE_CAMPAIGN_RESET]: () => ({
    createCampaign: { ...initialState.createCampaign },
  }),

  [UPDATE_CAMPAIGN]: draft => ({
    updateCampaign: {
      ...draft.updateCampaign,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_CAMPAIGN_SUCCESS]: (draft, action) => ({
    updateCampaign: {
      ...draft.updateCampaign,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_CAMPAIGN_ERROR]: (draft, action) => ({
    updateCampaign: {
      ...draft.updateCampaign,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_CAMPAIGN_RESET]: () => ({
    updateCampaign: { ...initialState.updateCampaign },
  }),
  [DELETE_CAMPAIGN]: draft => ({
    deleteCampaign: {
      ...draft.deleteCampaign,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [DELETE_CAMPAIGN_SUCCESS]: (draft, action) => ({
    deleteCampaign: {
      ...draft.deleteCampaign,
      loading: false,
      data: action.payload.data,
    },
  }),
  [DELETE_CAMPAIGN_ERROR]: (draft, action) => ({
    deleteCampaign: {
      ...draft.deleteCampaign,
      loading: false,
      error: action.payload.error,
    },
  }),
  [DELETE_CAMPAIGN_RESET]: () => ({
    deleteCampaign: { ...initialState.deleteCampaign },
  }),
  [GET_ROUTE_LIST]: draft => ({
    routeList: {
      ...draft.routeList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_ROUTE_LIST_SUCCESS]: (draft, action) => ({
    routeList: {
      ...draft.routeList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_ROUTE_LIST_ERROR]: (draft, action) => ({
    routeList: {
      ...draft.routeList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_ROUTE_LIST_RESET]: () => ({
    routeList: { ...initialState.routeList },
  }),

  [CREATE_ROUTE]: draft => ({
    createRoute: {
      ...draft.createRoute,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [CREATE_ROUTE_SUCCESS]: (draft, action) => ({
    createRoute: {
      ...draft.createRoute,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CREATE_ROUTE_ERROR]: (draft, action) => ({
    createRoute: {
      ...draft.createRoute,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CREATE_ROUTE_RESET]: () => ({
    createRoute: { ...initialState.createRoute },
  }),

  [UPDATE_ROUTE]: draft => ({
    updateRoute: {
      ...draft.updateRoute,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_ROUTE_SUCCESS]: (draft, action) => ({
    updateRoute: {
      ...draft.updateRoute,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_ROUTE_ERROR]: (draft, action) => ({
    updateRoute: {
      ...draft.updateRoute,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_ROUTE_RESET]: () => ({
    updateRoute: { ...initialState.updateRoute },
  }),
  [DELETE_ROUTE]: draft => ({
    deleteRoute: {
      ...draft.deleteRoute,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [DELETE_ROUTE_SUCCESS]: (draft, action) => ({
    deleteRoute: {
      ...draft.deleteRoute,
      loading: false,
      data: action.payload.data,
    },
  }),
  [DELETE_ROUTE_ERROR]: (draft, action) => ({
    deleteRoute: {
      ...draft.deleteRoute,
      loading: false,
      error: action.payload.error,
    },
  }),
  [DELETE_ROUTE_RESET]: () => ({
    deleteRoute: { ...initialState.deleteRoute },
  }),

  [DO_TEST_AUDIO_CALL]: draft => ({
    doTestAudioCall: {
      ...draft.doTestAudioCall,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [DO_TEST_AUDIO_CALL_SUCCESS]: (draft, action) => ({
    doTestAudioCall: {
      ...draft.doTestAudioCall,
      loading: false,
      data: action.payload.data,
    },
  }),
  [DO_TEST_AUDIO_CALL_ERROR]: (draft, action) => ({
    doTestAudioCall: {
      ...draft.doTestAudioCall,
      loading: false,
      error: action.payload.error,
    },
  }),
  [DO_TEST_AUDIO_CALL_RESET]: () => ({
    doTestAudioCall: { ...initialState.doTestAudioCall },
  }),

  [GET_PRIORITY_TEAM_LIST]: draft => ({
    priorityTeamList: {
      ...draft.priorityTeamList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_PRIORITY_TEAM_LIST_SUCCESS]: (draft, action) => ({
    priorityTeamList: {
      ...draft.priorityTeamList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_PRIORITY_TEAM_LIST_ERROR]: (draft, action) => ({
    priorityTeamList: {
      ...draft.priorityTeamList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PRIORITY_TEAM_LIST_RESET]: () => ({
    priorityTeamList: { ...initialState.priorityTeamList },
  }),

  [GET_PRIORITY_TEAM_DETAIL]: draft => ({
    priorityTeamDetail: {
      ...draft.priorityTeamDetail,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_PRIORITY_TEAM_DETAIL_SUCCESS]: (draft, action) => ({
    priorityTeamDetail: {
      ...draft.priorityTeamDetail,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_PRIORITY_TEAM_DETAIL_ERROR]: (draft, action) => ({
    priorityTeamDetail: {
      ...draft.priorityTeamDetail,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PRIORITY_TEAM_DETAIL_RESET]: () => ({
    priorityTeamDetail: { ...initialState.priorityTeamDetail },
  }),

  [CREATE_PRIORITY_TEAM]: draft => ({
    createPriorityTeam: {
      ...draft.createPriorityTeam,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [CREATE_PRIORITY_TEAM_SUCCESS]: (draft, action) => ({
    createPriorityTeam: {
      ...draft.createPriorityTeam,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CREATE_PRIORITY_TEAM_ERROR]: (draft, action) => ({
    createPriorityTeam: {
      ...draft.createPriorityTeam,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CREATE_PRIORITY_TEAM_RESET]: () => ({
    createPriorityTeam: { ...initialState.createPriorityTeam },
  }),

  [UPDATE_PRIORITY_TEAM]: draft => ({
    updatePriorityTeam: {
      ...draft.updatePriorityTeam,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_PRIORITY_TEAM_SUCCESS]: (draft, action) => ({
    updatePriorityTeam: {
      ...draft.updatePriorityTeam,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_PRIORITY_TEAM_ERROR]: (draft, action) => ({
    updatePriorityTeam: {
      ...draft.updatePriorityTeam,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_PRIORITY_TEAM_RESET]: () => ({
    updatePriorityTeam: { ...initialState.updatePriorityTeam },
  }),

  [ADD_DOCTOR_TO_PRIORITY_TEAM]: draft => ({
    addDoctorToPriorityTeam: {
      ...draft.addDoctorToPriorityTeam,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [ADD_DOCTOR_TO_PRIORITY_TEAM_SUCCESS]: (draft, action) => ({
    addDoctorToPriorityTeam: {
      ...draft.addDoctorToPriorityTeam,
      loading: false,
      data: action.payload.data,
    },
  }),
  [ADD_DOCTOR_TO_PRIORITY_TEAM_ERROR]: (draft, action) => ({
    addDoctorToPriorityTeam: {
      ...draft.addDoctorToPriorityTeam,
      loading: false,
      error: action.payload.error,
    },
  }),
  [ADD_DOCTOR_TO_PRIORITY_TEAM_RESET]: () => ({
    addDoctorToPriorityTeam: { ...initialState.addDoctorToPriorityTeam },
  }),

  [DELETE_PRIORITY_TEAM]: draft => ({
    deletePriorityTeam: {
      ...draft.deletePriorityTeam,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [DELETE_PRIORITY_TEAM_SUCCESS]: (draft, action) => ({
    deletePriorityTeam: {
      ...draft.deletePriorityTeam,
      loading: false,
      data: action.payload.data,
    },
  }),
  [DELETE_PRIORITY_TEAM_ERROR]: (draft, action) => ({
    deletePriorityTeam: {
      ...draft.deletePriorityTeam,
      loading: false,
      error: action.payload.error,
    },
  }),
  [DELETE_PRIORITY_TEAM_RESET]: () => ({
    deletePriorityTeam: { ...initialState.deletePriorityTeam },
  }),

}, initialState)
